import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'app/shared/shared.module';
import {DndModule} from 'ng2-dnd';
import {FormService} from '../../../shared/components/form/form.service';
import {CertificatesService} from './certificates.service';
import {CertificatesComponent} from './components/certificates.component';
import {CertificateCreateModalComponent} from './components/certificate-create-modal/certificate-create-modal.component';
import {CertificateDetailsComponent} from './components/details/certificate-details.component';
import {PhoenixCommonModule} from '../../../phoenix2/common/phoenix-common.module';
import {ValidityPeriodFormComponent} from './components/details/validity-period-form/validity-period-form.component';
import {DeactivateCertificateTemplateComponent} from './components/details/deactivate-certificate-template/deactivate-certificate-template.component';
import {CertificateNameFormComponent} from './components/details/certificate-name-form/certificate-name-form.component';
import {CertificateSelectModule} from '../../../common/certificate-select/certificate-select.module';
import { DeactivateCertificateConfirmComponent } from './components/details/deactivate-certificate-confirm/deactivate-certificate-confirm.component';
import { TemplateFileFormComponent } from './components/details/template-file-form/template-file-form.component';
import {CertificateUsedComponent} from './components/details/certificate-used/certificate-used.component';
import {CertificatesIssuedComponent} from './components/details/certificates-issued/certificates-issued.component';


@NgModule({
	imports: [
	    CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        DndModule.forRoot(),
        PhoenixCommonModule,
        CertificateSelectModule
    ],
    declarations: [
        CertificatesComponent,
        CertificateCreateModalComponent,
        CertificateDetailsComponent,
        CertificateNameFormComponent,
        ValidityPeriodFormComponent,
        DeactivateCertificateTemplateComponent,
        DeactivateCertificateConfirmComponent,
        TemplateFileFormComponent,
        CertificateUsedComponent,
        CertificatesIssuedComponent
    ],
    providers: [
        FormService,
        CertificatesService
    ],
    entryComponents: [
        CertificateCreateModalComponent,
        CertificateNameFormComponent,
        ValidityPeriodFormComponent,
        DeactivateCertificateTemplateComponent,
        DeactivateCertificateConfirmComponent,
        TemplateFileFormComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class CertificatesModule {
}



// WEBPACK FOOTER //
// ./src/app/organization/components/certificates/certificates.module.ts